function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Master",
  stroke: "none",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  transform: "translate(-41.000000, -457.000000)",
  fill: "#C2C5C6"
}, /*#__PURE__*/React.createElement("g", {
  id: "transaction",
  transform: "translate(41.000000, 457.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Shape-Copy-2",
  transform: "translate(5.500000, 4.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,22.5 C0,23.325 0.675,24 1.5,24 L19.5,24 C20.325,24 21,23.325 21,22.5 C21,21.675 20.325,21 19.5,21 L1.5,21 C0.675,21 0,21.675 0,22.5 Z M3.615,9.88875 L6,9.88875 L6,17.38875 C6,18.21375 6.675,18.88875 7.5,18.88875 L13.5,18.88875 C14.325,18.88875 15,18.21375 15,17.38875 L15,9.88875 L17.385,9.88875 C18.72,9.88875 19.395,8.26875 18.45,7.32375 L11.565,0.43875 C10.98,-0.14625 10.035,-0.14625 9.45,0.43875 L2.565,7.32375 C1.62,8.26875 2.28,9.88875 3.615,9.88875 Z",
  id: "Shape-Copy"
})))));

var SvgUpload = function SvgUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload.73b4312c.svg";
export { ForwardRef as ReactComponent };